import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class StatusColorService {
    /**
     * Gets a Color
     * @function getColorFunc
     * @memberOf score.talentPayroll.services.colorsService
     * @param label {String} - status label
     * @param property {String} - property
     * @returns {String} - a class representing a color
     * @private
     */
    getColorFunc(label, property?) {
        if (label && this[label.toLowerCase()]) {
            if (property) {
                return this[label.toLowerCase()][property];
            }
            return this[label.toLowerCase()].color;
        }
        return "";
    }

    /**
     * A public method to get colors
     * @function getColors
     * @memberOf score.talentPayroll.services.colorsService
     * @returns {Object} - look up for statuses to colors
     * @public
     */
    getColors() {
        return {
            paymentStatus: {
                "pending approval": { color: "tango", hex: "#F37021" },
                approved: { color: "chateau-green", hex: "#369E4C" },
                processed: { color: "vivid-violet", hex: "#93278F" },
                rejected: { color: "black", hex: "#000000" },
                "validation failed": {
                    color: "lightning-yellow",
                    hex: "#FFC013",
                },
                error: { color: "alizarin-crimson", hex: "#E32020" },
                "spb-pending authorization": {
                    color: "studio-authorization-pending",
                    hex: "#FCD5B4",
                },
                "spb-authorized": {
                    color: "studio-authorized",
                    hex: "#B3DDEB",
                },
                "spb-paid": { color: "studio-paid", hex: "#D8E4BC" },
                get: this.getColorFunc,
            },
            timesheetWorkflowStatus: {
                submitter: { color: "workflow-DeptOps-status", hex: "#4a90e2" },
                approver: {
                    color: "workflow-deptTalent-status",
                    hex: "#4a4a4a",
                },
                finance: {
                    color: "workflow-deptFinance-status",
                    hex: "#417505",
                },
                payroll: {
                    color: "workflow-deptPayroll-status",
                    hex: "#5a5a96",
                },
                approved: { color: "workflow-approved-status", hex: "#edff02" },
                get: this.getColorFunc,
            },
            timesheetWeekViewStatus: {
                submitted: { color: "lightning-yellow", hex: "#FFC013" },
                approved: { color: "pastel-green", hex: "#73d658" },
                white: { color: "white", hex: "#ffffff" },
                get: this.getColorFunc,
            },
        };
    }
}
